<template>
	<div
		:class="{ selected: selected }"
		class="card"
		@click="click"
	>
		<span
			v-if="soon"
			style="
				padding: 0 0.5rem;
				border-radius: 30px;
				color: white;
				position: absolute;
				background: var(--color-green);
				transform: translateY(-50%);
			"
			>{{ $t('comingSoon') }}</span
		>
		<div class="content">
			<h5 class="header">
				<slot name="header" />
			</h5>
			<div class="description">
				<slot name="description" />
			</div>
		</div>
		<div
			:class="{ selected: selected, disabled: soon }"
			class="ui bottom attached tiny button"
		>
			<i
				:class="[selected ? 'check' : 'add']"
				class="icon"
			/>
			<slot name="button-title" />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		selected: {
			type: Boolean,
			default: false,
			required: false,
		},
		soon: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		click() {
			this.$emit('click')
		},
	},
}
</script>

<style scoped>
.card {
	border: 1px solid #ccc;
	border-radius: 4px;
}

.content {
	padding: 1rem;
}

.ui.bottom.attached.tiny.button.selected {
	background-color: var(--color-green);
	color: white;
}

.card.selected {
	border-color: var(--color-green);
}
</style>
